export default "__VITE_ASSET__CtjOmqom__"